/**
 * 异常类型
 */
export var ErrorType;
(function (ErrorType) {
    /** 业务错误：请求成功，且 http status 200=<status<300 但 retcode !== 0 */
    ErrorType["BUSINESS"] = "business";
    /** 网络异常：请求中断 或 请求失败（网络层）或 （应用层）http status>=300 || status<200 或 网络超时*/
    ErrorType["HTTP"] = "http";
    /** 字符串解析报错 */
    ErrorType["JSON_PARSE"] = "jsonParse";
    /** 其他异常 */
    ErrorType["OTHER"] = "other";
})(ErrorType || (ErrorType = {}));
